export default {
  props: [ 'data', 'index'],
  methods: {
    destroy () {
      this.$store.commit('removeSubField', {
        field_id: this.data.field_id,
        index: this.index
      })
    },
    updateOptions (payload) {
      payload['id'] = this.data.id
      this.$store.commit('updateSubFieldOptions', payload)
    },
    update (payload) {
      payload['id'] = this.data.id
      this.$store.commit('updateSubField', payload)
    }
  }
}
